import { EmptyState } from '@components/EmptyState';
import { type ColumnProps, MessagesIcon, Table } from '@gurupay/gp-ui-library';
import type { IMessage } from '@hooks/useMessages';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { MessagesRenderers } from './MessagesRenderers';

interface MessagesTableProps {
	messages: IMessage[];
	isLoading: boolean;
}

export const MessagesTable = ({ messages, isLoading }: MessagesTableProps) => {
	const { t } = useTranslation('', { keyPrefix: 'dashboard.messages' });
	const navigate = useNavigate();
	const columns: ColumnProps[] = [{ label: '', key: 'messageInfo', align: 'left' }];

	const handleRowClick = ({ uuid }: IMessage) => {
		navigate(`/messages/${uuid}`);
	};

	const getRowClassname = ({ unread_count }: IMessage) =>
		unread_count
			? 'bg-brand-secondary-50 hover:bg-brand-secondary-100'
			: 'hover:bg-neutral-50';

	if (!isLoading && !messages.length) {
		return (
			<EmptyState
				buttonProps={{
					children: t('createMessage'),
					href: '/messages/new',
				}}
				icon={<MessagesIcon />}
				title={t('noMessages')}
			/>
		);
	}

	return (
		<Table
			className="p-space-8 [&_td]:p-space-8"
			columns={columns}
			getRowClassName={getRowClassname}
			isLoading={isLoading}
			onRowClick={handleRowClick}
			renders={MessagesRenderers(t)}
			rows={messages}
		/>
	);
};
